import React, { PureComponent } from 'react';
import { bool, func, object } from 'prop-types';

import * as yup from 'yup';

import { Field } from 'formik';

import Button, { GhostButton } from 'ui/Button';
import Form, { FormBody, FormFooter, FormSection } from 'ui/Form';
import Input from 'ui/Input';
import InputWrapper from 'components/InputWrapper';
import LoadingIndicator from 'ui/LoadingIndicator';
import Message from 'components/Message';
import Select from 'ui/Select';

class InnerForm extends PureComponent {
  getElementError = (element) =>
    this.props.touched[element] && this.props.errors[element];

  renderErrorMessage = () =>
    this.props.errors.description && (
      <Message type={Message.types.ERROR} withMarginBottom>
        {this.props.errors.description}
      </Message>
    );

  renderMainSection = () => {
    const { errors, setFieldTouched, setFieldValue, touched, values } =
      this.props;

    const FIRST_NAME = 'firstName';
    const firstNameError = this.getElementError(FIRST_NAME);
    const firstNameLabel = 'First name';
    const firstNamePlaceholder = 'e.g. John';

    const LAST_NAME = 'lastName';
    const lastNameError = this.getElementError(LAST_NAME);
    const lastNameLabel = 'Last name';
    const lastNamePlaceholder = 'e.g. Doe';

    const EMAIL = 'email';
    const emailError = this.getElementError(EMAIL);
    const emailLabel = 'Email';
    const emailPlaceholder = 'e.g. john.doe@email.com';

    const ROLE = 'role';
    const roleError = this.getElementError(ROLE);
    const roleLabel = 'Role';
    const roleOptions = [
      {
        label: 'Admin',
        value: 'admin'
      },
      {
        label: 'Presenter',
        value: 'presenter'
      }
    ];

    const roleValue = roleOptions.find(({ value }) => value === values.role);
    const roleStyles = {
      option: (base) => ({
        ...base,
        textTransform: 'capitalize'
      }),
      singleValue: (base) => ({
        ...base,
        textTransform: 'capitalize'
      })
    };

    return (
      <FormSection>
        <InputWrapper
          error={firstNameError}
          label={firstNameLabel}
          name={FIRST_NAME}
        >
          <Input
            as={Field}
            data-testid={FIRST_NAME}
            haserror={firstNameError}
            id={FIRST_NAME}
            name={FIRST_NAME}
            placeholder={firstNamePlaceholder}
          />
        </InputWrapper>
        <InputWrapper
          error={lastNameError}
          label={lastNameLabel}
          name={LAST_NAME}
        >
          <Input
            as={Field}
            data-testid={LAST_NAME}
            haserror={lastNameError}
            id={LAST_NAME}
            name={LAST_NAME}
            placeholder={lastNamePlaceholder}
          />
        </InputWrapper>
        <InputWrapper error={emailError} label={emailLabel} name={EMAIL}>
          <Input
            as={Field}
            data-testid={EMAIL}
            haserror={emailError}
            id={EMAIL}
            name={EMAIL}
            placeholder={emailPlaceholder}
          />
        </InputWrapper>
        <InputWrapper label={roleLabel} name={ROLE} error={roleError}>
          <Select
            data-testid={ROLE}
            haserror={!!errors.role}
            id={ROLE}
            name={ROLE}
            onBlur={setFieldTouched}
            onChange={setFieldValue}
            options={roleOptions}
            styles={roleStyles}
            touched={touched.role}
            value={roleValue}
          />
        </InputWrapper>
      </FormSection>
    );
  };

  renderButtons = () => (
    <FormSection noMarginBottom>
      <GhostButton
        disabled={this.props.isSubmitting}
        name="cancelBtn"
        onClick={this.props.hideModal}
        type="button"
      >
        Cancel
      </GhostButton>
      <Button disabled={this.props.isSubmitting} name="submitBtn" type="submit">
        Confirm
      </Button>
    </FormSection>
  );

  render() {
    const { handleSubmit, isSubmitting } = this.props;

    return (
      <Form onSubmit={handleSubmit}>
        {isSubmitting && <LoadingIndicator cover />}
        <FormBody>
          {this.renderErrorMessage()}
          {this.renderMainSection()}
        </FormBody>
        <FormFooter>{this.renderButtons()}</FormFooter>
      </Form>
    );
  }
}

InnerForm.validationSchema = yup.object({
  email: yup.string().email('(invalid email)').required('(required)'),
  firstName: yup.string().required('(required)'),
  lastName: yup.string().required('(required)'),
  role: yup.string().required('(required)')
});

InnerForm.propTypes = {
  errors: object,
  handleSubmit: func,
  hideModal: func.isRequired,
  isSubmitting: bool,
  setFieldTouched: func,
  setFieldValue: func,
  touched: object,
  values: object
};

export default InnerForm;
